<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('label.company')">
              <j-search-select-tag
                type="list"
                v-model="queryParam.companyCode"
                :triggerChange="true"
                :dictOptions="companyDictOptions"
                :placeholder="$t('label.pleaseSelectCompany')"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="$t('label.category')">
              <!--<j-dict-select-tag v-model="queryParam.breedVarietyCode"
                                 dictCode="pzlx"/>-->
              <j-dict-select-tag
                v-model="queryParam.breedVarietyCode"
                :triggerChange="true"
                @change="handleBreedClass"
                dictCode="sys_category,name,code,pid=(select id from sys_category where code='A01' AND name = '物种分类')"
                :placeholder="$t('label.pleaseSelectCategory')"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="$t('label.breedingStrain')">
              <!-- <j-dict-select-tag v-model="queryParam.breedStrainCode"
                                 dictCode="pxlx"/>-->
              <j-dict-select-tag
                :dictCode="dictBreedStrainCode"
                v-model="queryParam.breedStrainCode"
                :placeholder="$t('label.pleaseSelectBreed')"
              />
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="12">
              <a-form-item :label="$t('label.defaultVersion')">
                <a-radio-group :options="defaultFlagList" v-model="queryParam.defaultFlag" />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('button.search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                $t('button.reset')
              }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.up') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('button.add') }}</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('efs_std_farmer_standard')">{{$t('button.export')}}</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>
      </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />{{ $t('button.delete') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('button.batchOperation') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('tip.selected') }}
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >{{ $t('tip.term') }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{ x: true }"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('button.edit') }}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('button.more') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('button.details') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('button.delete') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <efs-std-farmer-standard-modal ref="modalForm" @ok="modalFormOk" />
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import EfsStdFarmerStandardModal from './modules/EfsStdFarmerStandardModal'
import '@/assets/less/TableExpand.less'
import { getAction } from '@/api/manage'

export default {
  name: 'EfsStdFarmerStandardList',
  mixins: [JeecgListMixin],
  components: {
    EfsStdFarmerStandardModal,
  },
  data() {
    return {
      description: 'efs_std_farmer_standard管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          slotName: 'tableHeader.company',
          // title: '公司',
          align: 'center',
          width: 310,
          dataIndex: 'companyCode_dictText',
          scopedSlots: { title: 'tableHeader.company'}
        },
        {
          slotName: 'tableHeader.grower',
          // title: '养户',
          align: 'center',
          width: 100,
          dataIndex: 'farmerCode_dictText',
          scopedSlots: { title: 'tableHeader.grower'}
        },
        {
          slotName: 'tableHeader.category',
          // title: '品类',
          align: 'center',
          width: 150,
          dataIndex: 'breedVarietyCode_dictText',
          scopedSlots: { title: 'tableHeader.category'}
        },
        {
          slotName: 'tableHeader.breed',
          // title: '品系',
          align: 'center',
          width: 180,
          dataIndex: 'breedStrainCode_dictText',
          scopedSlots: { title: 'tableHeader.breed'}
        },
        {
          slotName: 'tableHeader.version',
          // title: '版本',
          align: 'center',
          width: 230,
          dataIndex: 'version',
          scopedSlots: { title: 'tableHeader.version'}
        },
        {
          slotName: 'tableHeader.defaultVersion',
          // title: '默认版本',
          align: 'center',
          width: 50,
          dataIndex: 'defaultFlag_dictText',
          scopedSlots: { title: 'tableHeader.defaultVersion'}
        },
        {
          slotName: 'tableHeader.operation',
          // title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action', title: 'tableHeader.operation' },
        },
      ],
      url: {
        list: '/farmerStandard/efsStdFarmerStandard/list',
        delete: '/farmerStandard/efsStdFarmerStandard/delete',
        deleteBatch: '/farmerStandard/efsStdFarmerStandard/deleteBatch',
        exportXlsUrl: '/farmerStandard/efsStdFarmerStandard/exportXls',
        importExcelUrl: '/farmerStandard/efsStdFarmerStandard/importExcel',
        companyUrl: '/sys/sysDepart/getDepartListByPermission',
      },
      dictOptions: {},
      companyDictOptions: [],
      defaultFlagList: [
        { label: '是', value: 'Y' },
        { label: '否', value: 'N' },
      ],
      queryParam: { defaultFlag: 'Y' },
      dictBreedStrainCode:
        "sys_category,name,code,pid IN (select id from sys_category where code IN ('A01A01A01','A01A01A02','A01A02'))",
    }
  },
  created() {
    this.getCompanyDictOptions()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
    searchReset() {
      this.queryParam = { defaultFlag: 'Y' }
      this.loadData(1)
    },
    handleBreedClass(value) {
      this.queryParam.breedVarietyCode = value
      this.dictBreedStrainCode = "sys_category,name,code,pid=(select id from sys_category where code= '" + value + "')"
    },
    // 获取公司列表
    getCompanyDictOptions() {
      let that = this
      getAction(that.url.companyUrl, { orgCategory: '1' }).then((res) => {
        console.log(res)
        if (res.success) {
          that.companyDictOptions = res.result
        }
      })
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>